<template>
  <section :class="{'py-6':!isFormScreen, [className]: !!className}" class="px-0 md:px-10">
    <slot/>
  </section>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useDisplayStore } from '@/stores/useDisplayStore';

defineProps({
  className: String
})
  const displayStore = useDisplayStore();
const isFormScreen = computed(() => displayStore.isFormScreen)

</script>
